var _defs, _line, _line2, _path, _line3, _line4, _path2, _line5, _line6, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEduBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.84 30.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e2e2e2;stroke-linecap:round;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_edu_books") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.84,
    y1: 3.57,
    x2: 20.84,
    y2: 3.57
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.84,
    y1: 6.27,
    x2: 23.84,
    y2: 6.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.71,19.47H7.48a1.31,1.31,0,0,1-1.15-.68,1.33,1.33,0,0,1,0-1.36,5.48,5.48,0,0,0,.9-2.93,5.42,5.42,0,0,0-.9-2.92,1.35,1.35,0,0,1,0-1.37,1.31,1.31,0,0,1,1.15-.68H38.71c2.17,0,6.29,1,6.29,5S40.88,19.47,38.71,19.47Zm-30.1-2h30.1c.17,0,4.29,0,4.29-3s-4.12-3-4.29-3H8.61a7,7,0,0,1,0,5.94Z",
    transform: "translate(-6.16 -9.53)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.84,
    y1: 23.79,
    x2: 20.84,
    y2: 23.79
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.84,
    y1: 26.49,
    x2: 23.84,
    y2: 26.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.71,39.69H7.48A1.34,1.34,0,0,1,6.32,39a1.37,1.37,0,0,1,0-1.37,5.19,5.19,0,0,0,0-5.84,1.32,1.32,0,0,1,1.11-2.05H38.71c2.17,0,6.29,1,6.29,5S40.88,39.69,38.71,39.69Zm-30.1-2h30.1c.17,0,4.29,0,4.29-3s-4.12-3-4.3-3H8.61a7,7,0,0,1,0,5.94Z",
    transform: "translate(-6.16 -9.53)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36,
    y1: 13.67,
    x2: 18,
    y2: 13.67
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36,
    y1: 16.37,
    x2: 15,
    y2: 16.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.68,29.57H12.45c-2.18,0-6.29-1-6.29-5s4.11-5,6.29-5H43.68a1.31,1.31,0,0,1,1.15.68,1.35,1.35,0,0,1,0,1.37,5.19,5.19,0,0,0,0,5.84,1.35,1.35,0,0,1,0,1.37A1.31,1.31,0,0,1,43.68,29.57ZM12.45,21.63c-.17,0-4.29.05-4.29,3s4.12,3,4.29,3h30.1a7,7,0,0,1,0-5.94Z",
    transform: "translate(-6.16 -9.53)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEduBooks);
export default __webpack_public_path__ + "static/media/ic_edu_books.59b3a639e2d19274d20ca5dbb5344be0.svg";
export { ForwardRef as ReactComponent };